import PropTypes from 'prop-types';
import { ZButton, ZInput } from '@zanichelli/albe-web-components/react';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from '../..';
import { InputContainer, ModalBodyContainer } from '../../components';
import { getAssignmentByUniqueCode } from '../../../../actions/assignment';
import { generatePayloadForOpenAssignment } from './utils';
import { redirectToViewer } from '../../../../lib/utils';
import { setLazeLaunch } from '../../../../lib/axios';
import { InputType } from '@zanichelli/albe-web-components';

export const GetUserInfoModalBody = ({ assignmentUniqueCode, getAssignmentByUniqueCode }) => {
    const [inputMessage, setInputMessage] = useState(null);
    const [inputStatus, setInputStatus] = useState(null);
    const [inputValue, setInputValue] = useState(null);

    const invalidateInput = () => {
        setInputMessage('Il campo è obbligatorio');
        setInputStatus('error');
    };

    const onChange = (e) => {
        if (e.detail.validity.valueMissing) {
            invalidateInput();
        } else if (!!inputMessage && !!inputStatus) {
            setInputMessage(null);
            setInputStatus(null);
        }
        setInputValue(e.detail.value);
    };

    const onButtonClick = async () => {
        const trimmedInput = inputValue?.trim();
        if (!trimmedInput) {
            invalidateInput();
        } else {
            setLazeLaunch(trimmedInput);
            const assignment = await getAssignmentByUniqueCode(assignmentUniqueCode);
            const urlParams = new URLSearchParams(window.location.search);
            const payload = generatePayloadForOpenAssignment(assignment, trimmedInput, urlParams.get('from'));
            sessionStorage.clear();
            redirectToViewer(payload);
        }
    };

    return (
        <Modal title="Inserisci i tuoi dati" closeOnClickOutside={false}>
            <ModalBodyContainer>
                <InputContainer>
                    <span className="body-3-sb">{'Continua come ospite'}</span>
                    <ZInput
                        type={InputType.TEXT}
                        label="nome e cognome*"
                        placeholder="Nome e Cognome"
                        value={inputValue}
                        status={inputStatus}
                        message={inputMessage}
                        onInputChange={onChange}
                        required={true}
                    />
                </InputContainer>
                <ZButton type="submit" onClick={onButtonClick}>
                    {'Continua'}
                </ZButton>
            </ModalBodyContainer>
        </Modal>
    );
};

GetUserInfoModalBody.propTypes = {
    assignmentUniqueCode: PropTypes.string,
    getAssignmentByUniqueCode: PropTypes.func,
};

const mapStateToProps = (state) => ({
    assignmentUniqueCode: state.modal.assignmentUniqueCode,
});

const actionCreators = {
    getAssignmentByUniqueCode,
};

export default connect(mapStateToProps, actionCreators)(GetUserInfoModalBody);
